var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H2C1.17157 3 0.5 3.67157 0.5 4.5L0.5 13.5C0.5 14.3284 1.17157 15 2 15H10C10.8284 15 11.5 14.3284 11.5 13.5V4.5C11.5 3.67157 10.8284 3 10 3H8.5",
    stroke: "#F47A36",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20834 2.88474C3.37795 2.71427 3.74322 2.35765 3.99348 2.2924C4.20477 2.2373 4.36759 2.09055 4.42838 1.8994C4.5935 1.37999 5.12265 1 5.74994 1C6.37726 1 6.90645 1.38002 7.07159 1.89945C7.13229 2.09037 7.29472 2.2373 7.50575 2.29219C7.75629 2.35739 8.0387 2.71414 8.20845 2.88474C8.25921 3.01455 8.5 3.34229 8.5 3.4878V3.5C8.5 3.77614 8.27614 4 8 4H3.5C3.22386 4 3 3.77614 3 3.5V3.47787C3.0012 3.33602 3.15878 3.04255 3.20834 2.91577",
    stroke: "#F47A36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72441 7.5H4.275C4.12312 7.5 4 7.62312 4 7.775C4 7.92687 4.12312 8.04999 4.275 8.04999H7.72441C7.87628 8.04999 7.9994 7.92687 7.9994 7.775C7.9994 7.62312 7.87628 7.5 7.72441 7.5Z",
    fill: "#F47A36",
    stroke: "#F47A36",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72636 9.5H4.27695C4.12507 9.5 4.00195 9.62312 4.00195 9.775C4.00195 9.92687 4.12507 10.05 4.27695 10.05H7.72636C7.87824 10.05 8.00136 9.92687 8.00136 9.775C8.00136 9.62312 7.87824 9.5 7.72636 9.5Z",
    fill: "#F47A36",
    stroke: "#F47A36",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPod);
export default __webpack_public_path__ + "static/media/pod.16b3b40d48864bac8b9b593a6d942a0d.svg";
export { ForwardRef as ReactComponent };